export const API = "https://student-marklist.vercel.app"

